export function getPipelineColors(): string[] {
  return [
    `pipelines-silver`,
    `pipelines-gray`,
    `pipelines-salmon`,
    `pipelines-orange`,
    `pipelines-yellow`,
    `pipelines-green`,
    `pipelines-blue`,
    `pipelines-purple`,
    `pipelines-pink`,
  ]
}
